import { configureStore } from "@reduxjs/toolkit";
import vendorsReducer from "./redux_files/TrialBalance/Vendors.js";
import activeProductsReducer from "./redux_files/activeProductsSlice.js";
//import wholeSales Reducers
import dailyWholesaleReducer from "./redux_files/Dashboard/dailyWholesaleSlice.js";
import wholesaleProductsReducer from "./redux_files/Dashboard/Wholesales/wholesaleProductsSlice.js";
import wholesaleCustomersReducer from "./redux_files/Dashboard/Wholesales/wholesaleCustomersSlice";
import wholesaleUsersReducer from "./redux_files/Dashboard/Wholesales/wholesaleUsersSlice";
import wholesaleCollectionsReducer from "./redux_files/Dashboard/Wholesales/wholesaleCollectionsSlice.js";
import dailyPOSReducer from "./redux_files/Dashboard/dailyPOSSlice.js";
import salesDifferenceReducer from "./redux_files/Dashboard/salesDifferenceSlice.js";
import dailyPOSWithComboReducer from "./redux_files/Dashboard/dailyPOSSliceWithCombo.js";
import supervisorsPOSReducer from "./redux_files/Dashboard/SupervisorsPOSSlices.js";
import POSProductsReducer from "./redux_files/Dashboard/POSs/posProductsSlice.js";
import rmsPosProductsReducer from "./redux_files/Dashboard/POSs/rmsPosProductsSlice.js";
import POSBranchesReducer from "./redux_files/Dashboard/POSs/posBranchesSlice.js";
import authReducer from "./redux_files/authSlice.js";
import inventoryReducer from "./redux_files/Inventory/inventorySlice.js";
import liveSalesSlice from "./redux_files/Dashboard/liveSalesSlice.js";
import itemCostCategoriesReducer from "./redux_files/Inventory/itemCostCategoriesSlice.js";
import POSComboItemsReducer from "./redux_files/Dashboard/POSs/posComboItemsSlice.js";
import promotionItemsReducer from "./redux_files/Dashboard/POSs/promotionItemsSlice.js";
import inventoryProductsSlice from "./redux_files/Inventory/inventoryProductsSlice.js";
import unitsSlice from "./redux_files/Inventory/unitsSlice.js";
import usersReducer from "./redux_files/usersSlice";
import cardsCouponsReducer from "./redux_files/cardsCouponsSlice.js";
import loyaltyCardsUserSettingsReducer from "./redux_files/loyaltyCardsUserSettingsSlice.js";
import ordersSourceReducer from "./redux_files/ordersSourceSlice.js";
import ordersBranchSourceReducer from "./redux_files/ordersBranchSourceSlice";
import ordersBranchSourcePeriodReducer from "./redux_files/ordersBranchSourcePeriodSlice";
import branchesReducer from "./redux_files/branchesSlice.js";
// Warehouse slices
import WHWarehousesReducer from "./redux_files/Dashboard/Warehouses/whWarehousesSlice.js";
import WHProductsReducer from "./redux_files/Dashboard/Warehouses/whProductsSlice.js";
import WHGoodsIssuedReducer from "./redux_files/Dashboard/Warehouses/whGoodsIssuedSlice.js";

const store = configureStore({
  reducer: {
    auth: authReducer,
    TrialBalanceVendor: vendorsReducer,
    ActiveProducts: activeProductsReducer,
    dailyWholesale: dailyWholesaleReducer,
    wholesaleProducts: wholesaleProductsReducer,
    wholesaleCustomers: wholesaleCustomersReducer,
    wholesaleUsers: wholesaleUsersReducer,
    WholesaleCollections: wholesaleCollectionsReducer,
    dailyPOS: dailyPOSReducer,
    salesDifference: salesDifferenceReducer,
    supervisorsPOS: supervisorsPOSReducer,
    POSProducts: POSProductsReducer,
    rmsPosProducts: rmsPosProductsReducer,
    POSBranches: POSBranchesReducer,
    inventory: inventoryReducer,
    liveSales: liveSalesSlice,
    itemCostCategories: itemCostCategoriesReducer,
    dailyPOSWithCombo: dailyPOSWithComboReducer,
    POSComboItems: POSComboItemsReducer,
    promotionItems: promotionItemsReducer,
    inventoryProducts: inventoryProductsSlice,
    units: unitsSlice,
    users: usersReducer,
    cardsCoupons: cardsCouponsReducer,
    loyaltyCardsUserSettings: loyaltyCardsUserSettingsReducer,
    ordersSource: ordersSourceReducer,
    ordersBranchSource: ordersBranchSourceReducer,
    ordersBranchSourcePeriod: ordersBranchSourcePeriodReducer,
    branches: branchesReducer,
    WHWarehouses: WHWarehousesReducer,
    WHProducts: WHProductsReducer,
    WHGoodsIssued: WHGoodsIssuedReducer,
  },
});

export default store;
